import React from 'react';
import ConsistentHeader from '../ConsistentHeader/ConsistentHeader';
import { Outlet } from 'react-router';

function MainLayout() {
  return (
    <>
      <ConsistentHeader />
      <Outlet />
    </>
  );
}

export default MainLayout;
